import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { selectViewType, VIEW_TYPE } from 'src/app/slice';
import { RootState } from 'src/app/store';
import { PivotGroup } from './PivotGroup';
import { MobilePivot } from './MobilePivot';
import { PivotWrap } from './styles';
import { useChromeConfigContext } from 'src/providers/ChromeConfigContextProvider';
import { logger } from 'src/commons/utils/logger';
import { markComponentReady } from 'src/commons/utils/logWithTakt';
import { Components } from 'src/commons/constants';
import { usePivotNavBundle } from 'src/providers/PantherLocalizationProvider/PantherLocalizationProvider';
import { isStandardPageLayoutType } from 'src/commons/utils/helpers';

export const PivotNav: React.VFC<{
  viewType: VIEW_TYPE;
}> = ({ viewType }) => {
  const chromeConfig = useChromeConfigContext();
  let nestedPivotNav = chromeConfig.nestedPivotNav;
  const pivotNavTranslation = usePivotNavBundle();

  useEffect(function () {
    markComponentReady(Components.PIVOT_NAV);
  }, []);

  // Temporary support for old version of AACChromeAPI until all teams update to latest version of AACChromeAPI
  if (!nestedPivotNav) {
    if (chromeConfig.pivotNav === undefined) {
      return null;
    }

    logger.info(
      `nestedPivotNav in chromeConfig is undefined for page ${window.location.href}`,
    );

    const pivotNav = chromeConfig.pivotNav;
    nestedPivotNav = {
      menuItemGroups: [],
      selectedItemId: pivotNav.selectedItemId || '',
    };

    if (
      pivotNav?.items === undefined &&
      pivotNav?.menuItemGroups !== undefined
    ) {
      nestedPivotNav.menuItemGroups = pivotNav.menuItemGroups;
    } else {
      nestedPivotNav.menuItemGroups = [{ links: pivotNav?.items || [] }];
    }
  }

  const menuItemGroups = nestedPivotNav.menuItemGroups;
  const selectedItemId = nestedPivotNav.selectedItemId;
  const isMobile = viewType === VIEW_TYPE.MOBILE;
  const hasItems =
    menuItemGroups && menuItemGroups.some((group) => group.links.length > 0);

  if (!hasItems || !isStandardPageLayoutType(chromeConfig.pageLayoutType)) {
    return null;
  }

  if (!isMobile) {
    return (
      <PivotWrap
        id="J_AACChromePivotNav"
        data-ccx-e2e-id="aac-pivotitems"
        aria-label={pivotNavTranslation.getMessage('pivot-nav-desktop-label')}
      >
        {menuItemGroups.map((group, index) => {
          return (
            <PivotGroup
              key={'PivotGroup' + index}
              links={group.links}
              label={group.label}
              selectedItemId={selectedItemId}
              isLastGroup={index >= menuItemGroups.length - 1}
            />
          );
        })}
      </PivotWrap>
    );
  } else {
    return (
      <MobilePivot
        menuItemGroups={menuItemGroups}
        selectedItemId={selectedItemId}
      />
    );
  }
};

const connector = connect((state: RootState) => {
  return {
    viewType: selectViewType(state),
  };
});

export const ConnectedPivotNav = connector(PivotNav);
